import { Component, AfterViewInit, ViewChild, ElementRef, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiAuthService } from './services/api-auth.service';
import { Proveedor } from './models/Proveedor';
import { ApiParametrosService } from './services/api-parametros.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements AfterViewInit{
  @ViewChild('rfcRef', {static: false}) rfc: ElementRef;
  public email: string = ''; //Variable para guadar la clase is-invalid que se agrega a las propiedades de los input
  public pass: string = ''; //Variable para guadar la clase is-invalid que se agrega a las propiedades de los input
  public alerta: boolean = false; //Variable que se usa para mostrar o no el div de contraseña o correo incorrecto.
  public ingresar: boolean = true; //Controla el boton de ingresar donde se loguea el usuario
  public checkLogin: boolean = false; //Variable que se utiliza para saber si se encuntra logueado algun usuario o no
  public RFC: string = ''; //Guarda el RFC del usuario logueado para mostrar el parte superior derecha
  public url_activa: string; //Guarda la url del componente actual en la que se encuentra

  public activaDrop: number = 0; // //Controla el dropdown para que no haga conflicto
  public spinner: boolean = false; //Controla el comportamiento del spinner al estar cargando el inicio de sesion
  public btnIngresar: boolean = true; //Controla el comportamiento del boton de ingresar

  public errorEmail: string = ''; //Mensaje de error para el email
  public errorPass: string = ''; //Mensaje de error para el password

  public botonNoActivo: number = 0; //Controla el boton de perfil en la parte superior derecha, cuando el usuario se encuentra logueado
  public indtip:string ='0';
  //Patron que se ejecuta en el ingreso del email en el input
  emailPattern: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  public data = [
    {name: 'test', email: 'test@gmail.com', website:'test.com'},
    {name: 'test', email: 'test@gmail.com', website:'test.com'},
    {name: 'test', email: 'test@gmail.com', website:'test.com'},
    {name: 'test', email: 'test@gmail.com', website:'test.com'},
];
title = 'angulardatatables';

  //Creacion del FormGroup con sus determinados campos y sus validators.
  createFormGroup() {
    return new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      password: new FormControl('', [Validators.required])
    });
  }

  contactForm: FormGroup;
  constructor(private router: Router, private apiAuth: ApiAuthService, private apiParam: ApiParametrosService) {
    this.contactForm = this.createFormGroup();
  }

  ngAfterViewInit(){
      let proveedor: Proveedor;
      proveedor = this.apiAuth.getTokenDecoded();
      //this.indtip = proveedor.TipoProv;
      //Condifion para controlar el comportamiento del boton de perfil, dependiento del estatus(proveedor.Tipo) de la cuenta.
      if (proveedor !== null ){
        if (proveedor.Tipo === '2' || proveedor.Tipo === '1' || proveedor.Tipo === '3') {
          this.botonNoActivo = 1;
        }
        this.actualizaRFC(proveedor.RFC);
      }
      //Inicializa el evento click para que no se cierre el dropdwon al momento de dar click en ingresar.
      $(document).ready(function() {
        $('.dropdown-menu').on('click', function (e) {
          e.stopPropagation();
        });
      });
  }

  //Actualiza el dropdown de la parte superior derecha para mostrar el RFC del usuario logueado
  actualizaRFC(rfc) {
    this.rfc.nativeElement.innerText = rfc;
    //Para volver a cargar el dropdown y no haga conflicto
    if (this.activaDrop === 0) {
      $(document).ready(function() {
          $('.dropdown-toggle').click(function() {
            $(this).next('.dropdown-menu').slideToggle(200);
          });
          $('.dropdown-toggle').focusout(function() {
            $(this).next('.dropdown-menu').slideUp(400);
          });
        });
      this.activaDrop = 1;
    }
  }

  //Checa si se encuentra logueado algun usuario
  checaLogin() {
    if (this.apiAuth.getToken() == null) {
        this.checkLogin = false;
    } else {
        this.checkLogin = true;
    }
  }

  //Login
  onLogin() {
    /*Valida campos*/
    if (this.validaCampos()) {
        this.btnIngresar = false;
        this.spinner = true;
        let email = this.contactForm.get('email').value;
        let pass = this.contactForm.get('password').value;
        /*Valida credenciales*/
        this.apiAuth.onLogin(email, pass).subscribe(data =>
          {
            /*Si las credenciales son válidas*/
            if (data[0].success == true) {
              this.spinner = false;
              this.btnIngresar = true;
              this.alerta = false;
              this.checkLogin = true;
              this.apiAuth.setToken(data[0].info);
              /*Obtiene info del proveedor para mostrar el RFC en el botón "Ingresar" */
              let proveedor: Proveedor = this.apiAuth.getTokenDecoded();
              //this.indtip = proveedor.TipoProv;
              this.actualizaRFC(proveedor.RFC);
              console.log("Estado: "+proveedor.Tipo);
              if (proveedor.Tipo === '0') {
                this.botonNoActivo = 0;
                //console.error('No activo');
                this.router.navigate(['/registro-usuarios', '1']);
              } else if (proveedor.Tipo === '1') {
                this.botonNoActivo = 1;
                $('#app_mod_alerta').modal('show');
                //this.router.navigate(['/procs']);
              } else if (proveedor.Tipo === '2') {
                this.botonNoActivo = 1;
                $('#app_mod_alerta').modal('show');
                //console.error('No activo');
              } else if (proveedor.Tipo === '3') {
                this.router.navigate(['/home']);
                this.botonNoActivo = 1;
              } else if (proveedor.Tipo === '99') {
                this.botonNoActivo = 0;
                //Modal de error con mensaje de no se puede loguear
                $('#app_mod_error').modal('show');
                console.error('Error no se puede loguear');
              } else if (proveedor.Tipo === '4') {
                this.botonNoActivo = 0;
                console.error('Refrendo anual');
                //this.router.navigate(['/registro-usuarios', '0']);
               $('#app_mod_referendum').modal('show');

              }else if (proveedor.Tipo === '6') {
                this.botonNoActivo = 1;
                $('#success_refrendo').modal('show');
                //this.router.navigate(['/procs']);
              }else if (proveedor.Tipo === '5') {
                this.botonNoActivo = 0;
                this.router.navigate(['/registro-docsarch']);
              }else if (proveedor.Tipo === '7') {//asoledad 22/11/2022 Estatus solicitado por Erika Cabrera
                this.botonNoActivo = 0;
                $('#sin_contratacion').modal('show');
              }else if (proveedor.Tipo === '98') {//asoledad: 16/03/2023 Condicionados y en Baja
                this.botonNoActivo = 0;
                this.router.navigate(['/registro-docsarch']);
              }
            } else {
                this.spinner = false;
                this.btnIngresar = true;
                this.alerta = true;
            }
          },
          error => {
            this.spinner = false;
            this.btnIngresar = true;
            this.alerta = true;
          });
    } else {
      this.alerta = true;
    }
  }
//Enviar a captura de datos
  refrendo(){
    $('#app_mod_referendum').modal('hide');
    this.botonNoActivo = 0;
                this.router.navigate(['/registro-usuarios', '1']);
  }

  //Cerrar sesion
  cerrarSesion() {
    this.apiAuth.deleteToken();
    setTimeout(() => {
    window.location.reload();
    }, 500);
  }


  cerrarError() {
    this.cerrarSesion();
  }

  //Validacion que los campos sean ingresados correctamente
    validaCampos() {
      let bandValida = true;
      if (this.contactForm.controls.email.hasError('required')) {
          this.email = 'is-invalid';
          bandValida = false;
          this.errorEmail = 'Ingrese un correo';
      } else if (this.contactForm.controls.email.hasError('pattern')) {
          this.email = 'is-invalid';
          this.errorEmail = 'Ingrese un correo valido';
          bandValida = false;
      } else {
          this.email = '';
          this.errorEmail = '';
      }

      if (this.contactForm.controls.password.hasError('required')) {
        this.pass = 'is-invalid';
        bandValida = false;
        this.errorPass = 'Ingrese la contraseña';
      } else {
        this.pass = '';
        this.errorPass = '';
      }

      return bandValida;
    }

    //Controla el comportamiento de mostrar o no el dropdown de login, dependiento de la vista en que se encuentre
    onActivate(evento) {
      let url = evento.router.routerState.snapshot.url;
      this.url_activa = url;
      switch(url) {
        case '/aviso-privacidad':
          this.ingresar = true;
          break;
        case '/registro':
          this.ingresar = false;
          break;
        case '/login':
          this.ingresar = false;
          break;
        case '/restablecer':
          this.ingresar = false;
          break;
        case '/restablecer-contrasena':
          this.ingresar = false;
          break;
         case '/reenviar-correo':
           this.ingresar = false;
           break;
        default:
          this.ingresar = true;
      }
      this.checaLogin();
      if (this.ingresar) {
        setTimeout( () => {
          let proveedor: Proveedor = this.apiAuth.getTokenDecoded();
          if (proveedor !== null ){
            this.actualizaRFC(proveedor.RFC);
          }
        }, 1);
      }
    }

    //Se loguea cuando se hace el preregistro de algun usuario
    onLoginRegistro(correo: string, pass: string) {
      this.apiAuth.onLogin(correo, pass).subscribe(data =>
        {
          /*Si las credenciales son válidas*/
          if (data[0].success == true) {
            this.alerta = false;
            this.checkLogin = false;
            this.apiAuth.setToken(data[0].info);
            /*Obtiene info del proveedor para mostrar el RFC en el botón "Ingresar" */
            let proveedor: Proveedor = this.apiAuth.getTokenDecoded();
            this.actualizaRFC(proveedor.RFC);
            this.checaLogin();
          }
        });
    }
}
